import React from 'react';
import styled from 'styled-components';

import cssObj from '../../../assets/css/cssObj';

import BlueskyIcon from '../../../assets/images/svgs/bluesky.svg';
import GitHubIcon from '../../../assets/images/svgs/github.svg';
import Goodreads from '../../../assets/images/svgs/goodreads.svg';
import LetterboxdIcon from '../../../assets/images/svgs/letterboxd.svg';
import LinkedInIcon from '../../../assets/images/svgs/linkedin2.svg';
import MastodonIcon from '../../../assets/images/svgs/mastodon.svg';
import PixelfedIcon from '../../../assets/images/svgs/pixelfed.svg';
import StorygraphIcon from '../../../assets/images/svgs/storygraph.svg';

const FooterContainer = styled.footer`
    align-items: center;
    background-color: ${cssObj.vars.teal};
    border-top: 0.2rem solid ${cssObj.vars.brown};
    bottom: 0;
    color: #ffffff;
    display: flex;
    height: 3rem;
    justify-content: space-between;
    left: 0;
    padding: 0 1rem;
    position: fixed;
    right: 0;
    z-index: 2;

    @media (min-width: ${cssObj.vars.xLargeBreakPoint}) {
        left: ${cssObj.vars.verticalHeaderWidth};
    }
`;

const FooterContent = styled.p`
    flex: 1;
    font-family: ${cssObj.vars.nunitoSans};
    font-size: 0.8rem;
    font-weight: 200;
`;

const CopyrightWord = styled.span`
    display: none;

    @media (min-width: ${cssObj.vars.midBreakPoint}) {
        display: initial;
    }
`;

const SocialContainer = styled.div`
    display: flex;
    justify-content: space-between;
    min-width: 11rem;

    > a > svg {
        fill: #ffffff;
        max-width: 1rem;
        transition: ${cssObj.vars.standardTransition};

        @media (min-width: ${cssObj.vars.smallBreakPoint}) {
            max-width: 1.25rem;
        }
    }

    > a {
        ${cssObj.mixins.activeHoverFocus(`
            > svg {
                fill: ${cssObj.vars.brown};
            }
        `)}
    }

    @media (min-width: ${cssObj.vars.smallBreakPoint}) {
        min-width: 14rem;
    }
`;

const IconLink = styled.a``;

const Footer = ({ children }) => {
    return (
        <FooterContainer>
            <FooterContent>
                <CopyrightWord>Copyright</CopyrightWord> © {new Date().getFullYear()} Geoff George
            </FooterContent>
            <SocialContainer>
                <IconLink href="https://bsky.app/profile/geoffdgeorge.com" target="_blank">
                    <BlueskyIcon />
                </IconLink>
                <IconLink rel="me" href="https://mastodon.social/@geoffdgeorge" target="_blank">
                    <MastodonIcon />
                </IconLink>
                <IconLink href="https://pixelfed.social/geoffdgeorge" target="_blank">
                    <PixelfedIcon />
                </IconLink>
                <IconLink href="https://letterboxd.com/geoffdgeorge" target="_blank">
                    <LetterboxdIcon />
                </IconLink>
                <IconLink href="https://app.thestorygraph.com/profile/geoffdgeorge" target="_blank">
                    <StorygraphIcon />
                </IconLink>
                <IconLink href="https://www.goodreads.com/user/show/336691-geoff" target="_blank">
                    <Goodreads />
                </IconLink>
                <IconLink href="https://github.com/geoffdgeorge" target="_blank">
                    <GitHubIcon />
                </IconLink>
                <IconLink href="https://www.linkedin.com/in/geoff-george/" target="_blank">
                    <LinkedInIcon />
                </IconLink>
            </SocialContainer>
        </FooterContainer>
    );
};

export default Footer;
